document.addEventListener('DOMContentLoaded', function () {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        console.warn("GSAP or one of its required plugins (ScrollTrigger/SplitText) is missing for the tagline section.");
        return;
    }

    // Prevent the browser from automatically jumping to a hash on page load
    if (window.location.hash) {
        if ('scrollRestoration' in history) {
            history.scrollRestoration = 'manual';
        }
        window.scrollTo(0, 0);
    }

    const hero = document.querySelector('.hero-section') ? document.querySelector('.hero-section') : null;
    const hamburgerContainer = document.querySelector('.hamburger-menu');
    const hamburgerButton = document.querySelector('.hamburger-menu__button');
    const closeButton = document.querySelector('.close-menu__button');
    const overlay = document.querySelector('.fullscreen-menu');

    if (hero) {
        gsap.set(hamburgerContainer, { yPercent: -120 });
        gsap.to(hamburgerContainer, {
            yPercent: 0,
            ease: "power2.out",
            scrollTrigger: {
                trigger: hero,
                start: "bottom top",
            }
        });
    }

    let scrollTop = 0;

    hamburgerButton.addEventListener('click', function (e) {
        e.preventDefault();
        overlay.showModal();
        gsap.fromTo(overlay, { opacity: 0 }, { opacity: 1, duration: 0.15 });
        scrollTop = window.scrollY;
        document.body.classList.add('is-fixed');
    });

    // --- Handle Anchor Links inside the Menu ---
    const menuLinks = overlay.querySelectorAll('a[href*="#"]');

    menuLinks.forEach(link => {
        link.addEventListener('click', (e) => {
            const href = link.getAttribute('href');
            const url = new URL(link.href);
            const isSamePage = url.pathname === window.location.pathname ||
                (url.pathname === '/' && window.location.pathname === '/');

            if (isSamePage) {
                e.preventDefault();
                const targetId = url.hash;
                if (!targetId || targetId === "#") return;

                // 1. Close the menu first
                gsap.to(overlay, {
                    opacity: 0,
                    duration: 0.15,
                    onComplete: () => {
                        overlay.close();
                        document.body.classList.remove('is-fixed');

                        ScrollTrigger.refresh();
                        document.querySelector(targetId)?.scrollIntoView({ behavior: 'smooth' });
                        // Update the URL hash without triggering default jump
                        history.pushState(null, null, targetId);
                    }
                });
            } else {
                // Different page: just clean up body class
                document.body.classList.remove('is-fixed');
            }
        });
    });

    closeButton.addEventListener('click', function (e) {
        e.preventDefault();
        gsap.to(overlay, {
            opacity: 0,
            duration: 0.15,
            onComplete: () => {
                overlay.close();
                document.body.classList.remove('is-fixed');
            }
        });
    });

    // --- Handling Cross-Page Jumps (The "Instant" Jump) ---
    // We wait for 'load' AND a small delay to ensure all GSAP pinning is calculated.
    // window.addEventListener('load', () => {
    //     if (window.location.hash && window.lenis && ScrollTrigger) {
    //         // Reset to top immediately on load to ensure clean calculation
    //         window.scrollTo(0, 0);
    //         setTimeout(() => {
    //             ScrollTrigger.refresh();
    //         }, 400);

    //         ScrollTrigger.addEventListener("refresh", function () {
    //             // this code will run AFTER all ScrollTriggers refreshed. 
    //             window.lenis.scrollTo(window.location.hash, {
    //                 imediate: true,
    //             });
    //         });
    //     }
    // });
});